"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorElementTags = exports.AnchorElementKind = void 0;
// eslint-disable-next-line
// TODO: find a way to use either Kind or Tag, or a more elegant way to denote one another
var AnchorElementKind;
exports.AnchorElementKind = AnchorElementKind;

(function (AnchorElementKind) {
  AnchorElementKind["LINK"] = "link";
  AnchorElementKind["BUTTON"] = "button";
  AnchorElementKind["SUBMIT"] = "submit";
})(AnchorElementKind || (exports.AnchorElementKind = AnchorElementKind = {}));

var AnchorElementTags;
exports.AnchorElementTags = AnchorElementTags;

(function (AnchorElementTags) {
  AnchorElementTags["DIV"] = "div";
  AnchorElementTags["SPAN"] = "span";
  AnchorElementTags["BUTTON"] = "button";
  AnchorElementTags["LINK"] = "a";
})(AnchorElementTags || (exports.AnchorElementTags = AnchorElementTags = {}));